module.exports = __webpack_public_path__ + "static/media/70002.4e1bb967.png";